var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal in",
      class: { "fade modal-open": _vm.isModalOpen },
      on: {
        click: function($event) {
          if ($event.target !== $event.currentTarget) {
            return null
          }
          $event.stopPropagation()
          return _vm.closeModal($event)
        }
      }
    },
    [
      _c("div", { staticClass: "modal-dialog" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c(
            "div",
            { staticClass: "modal__header", class: _vm.headerClasses },
            [
              _c("div", { staticClass: "modal__header--angles" }, [
                _c("img", {
                  staticClass: "modal__profile-pic",
                  attrs: { src: _vm.item.headshot }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "modal__contact-name" }, [
                  _vm._v(_vm._s(_vm.item.fullName))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal__contact-position" }, [
                  _vm._v(_vm._s(_vm.item.title))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal__contact-row" }, [
                  _c("div", { staticClass: "modal__contact-phone" }, [
                    _vm._v(_vm._s(_vm.item.phone))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal__contact-separator" }, [
                    _vm._v("|")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal__contact-email" }, [
                    _vm._v(_vm._s(_vm.item.email))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal__close-btn" }, [
                  _c("i", {
                    staticClass: "fa fa-times",
                    on: { click: _vm.closeModal }
                  })
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "modal-body" }, [
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.text,
                  expression: "text"
                }
              ],
              staticClass: "modal__comment-block",
              attrs: { placeholder: "Send a message..." },
              domProps: { value: _vm.text },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.text = $event.target.value
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal__footer" }, [
            _vm.isSending
              ? _c(
                  "div",
                  { staticClass: "modal__sending-overlay" },
                  [
                    _c("moon-loader", {
                      attrs: { size: "25px", color: "#1176BB" }
                    })
                  ],
                  1
                )
              : _c(
                  "div",
                  {
                    staticClass: "modal__send-btn",
                    on: { click: _vm.sendMessage }
                  },
                  [_vm._v("Send")]
                )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }